import React from "react";
import { Divider } from "@mui/material";
import CompletionNotificationSection from "./advanced/CompletionNotificationSection";
import DeleteAgentSection from "./advanced/DeleteAgentSection";
import ExamplePromptsSection from "./advanced/ExamplePromptsSection";
import SelfConfigurationSection from "./advanced/SelfConfigurationSection";
import TranscriptVisibilitySection from "./advanced/TranscriptVisibilitySection";

export default function AdvancedTab(props) {
  const { isSystemAgent, isMasterAgent, isCreateMode, agentId } = props;
  const showDeleteSection =
    !isCreateMode && agentId && !isSystemAgent && !isMasterAgent;

  return (
    <>
      {!isSystemAgent && (
        <>
          <SelfConfigurationSection {...props} />
          <Divider sx={{ borderColor: "divider", my: 2.5 }} />
          <CompletionNotificationSection {...props} />
        </>
      )}

      <ExamplePromptsSection {...props} />

      <TranscriptVisibilitySection {...props} />

      {showDeleteSection && (
        <>
          <Divider sx={{ borderColor: "divider", my: 2.5 }} />
          <DeleteAgentSection {...props} />
        </>
      )}
    </>
  );
}
